export const transformCompositionToWeb = (comp) =>
{
	return Object.assign({}, comp, 
	{
		lat: comp.latitude,
		lng: comp.longitude,
	});
}

export const transformCompositionsToWeb = (comps)=>
{
	return comps.map((c)=>transformCompositionToWeb(c));
}


// WEBPACK FOOTER //
// ./js/DataTransformations.jsx